import { authenticatedApi, ApiError, API_BASE_URL } from './apiUtils';

const impersonationApi = {
  /**
   * Start impersonating a user
   * @param {string} targetEmployeeId - ID of the employee to impersonate
   * @param {string} reason - Reason for impersonation
   * @returns {Promise<Object>} Impersonation session details
   */
  async startImpersonation(targetEmployeeId, reason) {
    try {
      return await authenticatedApi.post(`${API_BASE_URL}/impersonation/start`, { targetEmployeeId, reason });
    } catch (error) {
      if (error.status === 403) {
        throw new ApiError(error.data?.error || 'You are not authorized to impersonate this employee', 403);
      }
      if (error.status === 404) {
        throw new ApiError(error.data?.error || 'Employee not found', 404);
      }
      throw new ApiError('Failed to start impersonation', error.status || 500);
    }
  },

  /**
   * End the current impersonation session
   * @returns {Promise<Object>} Success response
   */
  async endImpersonation() {
    try {
      return await authenticatedApi.post(`${API_BASE_URL}/impersonation/end`);
    } catch (error) {
      throw new ApiError('Failed to end impersonation', error.status || 500);
    }
  },

  /**
   * Get current impersonation status
   * @returns {Promise<Object>} Current impersonation status
   */
  async getStatus() {
    try {
      return await authenticatedApi.get(`${API_BASE_URL}/impersonation/status`);
    } catch (error) {
      throw new ApiError('Failed to get impersonation status', error.status || 500);
    }
  },

  /**
   * Get all active impersonation sessions for the current user
   * @returns {Promise<Object>} List of active sessions
   */
  /*
  async getActiveSessions() {
    try {
      return await authenticatedApi.get(`${API_BASE_URL}/impersonation/sessions`);
    } catch (error) {
      throw new ApiError('Failed to get active sessions', error.status || 500);
    }
  },
  */

  /**
   * Search for employees to impersonate
   * @param {string} query - Search query
   * @returns {Promise<Object>} List of matching employees
   */
  /*
  async searchEmployees(query) {
    try {
      const queryParams = new URLSearchParams();
      if (query) queryParams.append('query', query);
      
      const queryString = queryParams.toString();
      return await authenticatedApi.get(`${API_BASE_URL}/impersonation/search?${queryString}`);
    } catch (error) {
      throw new ApiError('Failed to search employees', error.status || 500);
    }
  },
  */
};

export default impersonationApi;